import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import {
    IApplicationState, AppActionCreators, IAppState, IMicrositeResponse, MicrositeActionCreators, IMicrositeDashRegistration, IMicrositeShortCodeResponse,
    IMicrositeLookupDataResponse, IExistingRegistrationsResponse, DashActionCreators, IAddressValidationResponse
} from '@nkr/store/index';
import { AddressValidationResult, ContactEntityType, MicrositeRecipientStatus, ShortCodeType, UserGroup } from '@nkr/enums/index';
import { ICenterBase, IContact, IListItem, IMicrositeRecipientRequest, IUsPsAddressResponse } from '@nkr/models/index';
import { Alert, Button, Checkbox, Col, ControlLabel, FormControl, FormGroup, HelpBlock, InputGroup, Label, Panel, Radio, Row, Well } from 'react-bootstrap';
import { AddEditWrapper, FormWrapper } from '../styles';
import { toast } from 'react-toastify';
import { Utility } from '@nkr/services/utility';
import { MicrositeSearchProvider } from '../list/context';
import { initialValidation, IValidation } from './validation';
import { CityValidation } from './city-validation';
import { generateQRCodePngDataURL } from '../campaigns/letter/campaign-document';
import CoachSelector from '../list/coach-selector';
import MaskedInput from 'react-maskedinput';
import AddressValidation, { IAddress } from '@nkr/components/address-validation';
import ConfirmChanges, { IChangedDetail } from './confirm-changes';

interface IProps {
    micrositeId: number;
    centerId: number;
    isAdmin: boolean;
    isConfirm: boolean;
    previousUrl: string;
    previousName: string;
    isCoachView?: boolean;
}

interface IStateProps {
    app: IAppState;
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getMicrosite: (id: number, forCoach: boolean, confirm: boolean) => Promise<IMicrositeResponse>,
    getLookupData: (centerId: number, micrositeRecipientId: number) => Promise<IMicrositeLookupDataResponse>,
    getShortCode: (type: ShortCodeType) => Promise<IMicrositeShortCodeResponse>,
    saveMicrosite: (request: IMicrositeRecipientRequest) => Promise<IMicrositeResponse>,
    checkForExistingRegistrations: (email: string, firstName: string, lastName: string, birthDate: string) => Promise<IExistingRegistrationsResponse>,
    validateAddress: (addressLine1: string, addressLine2: string, city: string, state: string, postalCode: string) => Promise<IAddressValidationResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    id: number,
    shortCode: string,
    confirmShortCode: boolean,
    editKey: string,
    centerId: number,
    micrositeTypeId: number,
    coordinatorContactId: number,
    secondaryCoordinatorContactId: number,
    coachContactId: number,
    email: string,
    secondaryEmail: string,
    firstName: string,
    lastName: string,
    currentStatusId: number,
    isTestSite: boolean,
    addressLine1: string,
    addressLine2: string,
    city: string,
    stateId: number,
    postalCode: string,
    phonePrimary: string,
    primaryPhoneCanReceiveTexts: boolean,
    phoneSecondary: string,
    secondaryPhoneCanReceiveTexts: boolean,
    birthdate: string,
    genderId: number,
    languagePreferenceId: number,
    isCoachingDesired: boolean,
    aboTypeId: number,
    agreedToHipaa: boolean,
    isResponsibilityConfirmed: boolean,
    receiveWeeklyUpdate: boolean,
    transplantDate: string,
    donorOrigin: number,
    transplantedFromDashRegistration: boolean,
    dashRegistrationId: number,
    reason: string,
    guardianFirstName: string,
    guardianLastName: string,
    guardianEmail: string,
    guardianPhone: string,
    isVeteran: boolean | null,
    isVeteranUnknown: boolean,
    branchOfService: number,
    hasChampion: boolean,
    championName: string,
    championEmail: string,
    championPhone: string,
    validation: IValidation,
    addressValidation: { show: boolean, response: IUsPsAddressResponse, submittedAddress: IAddress },
    previousLocation: string,
    originalCenterId: number,
    campaignId: number,
    campaignName: string,
    qrCode: string | null,
    coordinatorList: IContact[],
    coachList: IContact[],
    statusList: IListItem[],
    genderList: IListItem[],
    stateList: IListItem[],
    donorOriginList: IListItem[],
    languageList: IListItem[],
    micrositeTypeList: IListItem[],
    dashRegistrationList: IMicrositeDashRegistration[],
    centerList: ICenterBase[],
    aboTypeList: IListItem[],
    armedServiceList: IListItem[],
    dirty: boolean,
    isCoachingDesiredOnLoad: boolean,
    disableSubmit: boolean,
    pendingSave: { addressLine1: string, city: string, stateId: number, postalCode: string } | null,
}

class MicrositeAddEdit extends React.Component<TProps, IState> {
    readonly state: IState = {
        id: 0,
        shortCode: '',
        confirmShortCode: false,
        editKey: '',
        centerId: 0,
        micrositeTypeId: 0,
        coordinatorContactId: 0,
        secondaryCoordinatorContactId: 0,
        coachContactId: 0,
        email: '',
        secondaryEmail: '',
        firstName: '',
        lastName: '',
        currentStatusId: MicrositeRecipientStatus.InvitationSent,
        isTestSite: false,
        addressLine1: '',
        addressLine2: '',
        city: '',
        stateId: 0,
        postalCode: '',
        phonePrimary: '',
        primaryPhoneCanReceiveTexts: false,
        phoneSecondary: '',
        secondaryPhoneCanReceiveTexts: false,
        birthdate: '',
        genderId: 0,
        languagePreferenceId: -1,
        isCoachingDesired: true,
        aboTypeId: -1,
        agreedToHipaa: false,
        isResponsibilityConfirmed: false,
        receiveWeeklyUpdate: true,
        transplantDate: '',
        donorOrigin: -1,
        transplantedFromDashRegistration: false,
        dashRegistrationId: -2,
        reason: '',
        guardianFirstName: null,
        guardianLastName: null,
        guardianEmail: null,
        guardianPhone: null,
        isVeteran: null,
        isVeteranUnknown: false,
        branchOfService: -1,
        hasChampion: false,
        championName: '',
        championEmail: '',
        championPhone: '',
        validation: { ...initialValidation },
        addressValidation: {
            show: false,
            response: null,
            submittedAddress: null
        },
        previousLocation: '',
        originalCenterId: 0,
        campaignId: 0,
        campaignName: '',
        qrCode: null,
        coordinatorList: [],
        coachList: [],
        statusList: [],
        genderList: [],
        stateList: [],
        donorOriginList: [],
        languageList: [],
        micrositeTypeList: [],
        dashRegistrationList: [],
        centerList: [],
        aboTypeList: [],
        armedServiceList: [],
        dirty: false,
        isCoachingDesiredOnLoad: false,
        disableSubmit: false,
        pendingSave: null,
    };

    originalState: IState = null;

    componentDidMount = () => {
        let previousLocation = this.getPreviousUrl();

        if (this.props.micrositeId > 0) {
            this.props.showLoading('Getting the microsite, one moment please...').then(() => {
                Promise.all([
                    this.props.getMicrosite(this.props.micrositeId, this.props.isCoachView == true, this.props.isConfirm),
                    this.props.getLookupData(this.props.centerId, this.props.micrositeId),
                ]).then(async ([response, lookupDataResponse]) => {
                    if (response.data.success && lookupDataResponse.data.success) {
                        let {
                            id,
                            shortCode,
                            editKey,
                            centerId,
                            coordinatorContactId,
                            secondaryCoordinatorContactId,
                            coachContactId,
                            email,
                            secondaryEmail,
                            firstName,
                            lastName,
                            currentStatusId,
                            isTestSite,
                            addressLine1,
                            addressLine2,
                            city,
                            stateId,
                            postalCode,
                            phonePrimary,
                            primaryPhoneCanReceiveTexts,
                            phoneSecondary,
                            secondaryPhoneCanReceiveTexts,
                            birthdate,
                            genderId,
                            languagePreferenceId,
                            agreedToHipaa,
                            isResponsibilityConfirmed,
                            isPatientUpdateEnabled: receiveWeeklyUpdate,
                            submissionLastIssue,
                            transplantDate,
                            donorOrigin: donorOrigin,
                            dashRegistrationId,
                            transplantedFromDashRegistration,
                            micrositeTypeId,
                            aboTypeId,
                            isCoachingDesired,
                            campaignId,
                            campaignName,
                            isVeteran,
                            branchOfService,
                            guardianFirstName,
                            guardianLastName,
                            guardianEmail,
                            guardianPhone,
                            hasChampion,
                            championName,
                            championEmail,
                            championPhone
                        } = response.data.results;

                        let {
                            coordinatorList,
                            coachList,
                            statusList,
                            genderList,
                            stateList,
                            donorOriginList,
                            languageList,
                            micrositeTypeList,
                            dashRegistrationList,
                            centerList,
                            aboTypeList,
                            armedServiceList
                        } = lookupDataResponse.data.results;

                        let qrCode = await generateQRCodePngDataURL(`${__NKR_ORG_URL__}/register/${shortCode}`);

                        this.setState({
                            id,
                            shortCode,
                            editKey,
                            centerId,
                            micrositeTypeId,
                            coordinatorContactId,
                            secondaryCoordinatorContactId,
                            coachContactId,
                            email,
                            secondaryEmail,
                            firstName,
                            lastName,
                            currentStatusId,
                            isTestSite,
                            addressLine1,
                            addressLine2,
                            city,
                            stateId,
                            postalCode,
                            phonePrimary,
                            primaryPhoneCanReceiveTexts,
                            phoneSecondary,
                            secondaryPhoneCanReceiveTexts,
                            birthdate,
                            genderId,
                            languagePreferenceId,
                            aboTypeId,
                            agreedToHipaa,
                            isResponsibilityConfirmed,
                            receiveWeeklyUpdate,
                            transplantDate,
                            reason: currentStatusId == MicrositeRecipientStatus.Inactive ? submissionLastIssue : '',
                            donorOrigin,
                            dashRegistrationId,
                            transplantedFromDashRegistration,
                            previousLocation,
                            originalCenterId: centerId,
                            qrCode,
                            coordinatorList,
                            coachList,
                            statusList,
                            genderList,
                            stateList,
                            donorOriginList,
                            languageList,
                            dashRegistrationList,
                            micrositeTypeList,
                            centerList,
                            aboTypeList,
                            armedServiceList,
                            isCoachingDesired,
                            isCoachingDesiredOnLoad: isCoachingDesired,
                            campaignId,
                            campaignName,
                            isVeteran,
                            isVeteranUnknown: isVeteran === null,
                            branchOfService,
                            guardianFirstName,
                            guardianLastName,
                            guardianEmail,
                            guardianPhone,
                            hasChampion,
                            championName: championName ?? '',
                            championEmail: championEmail ?? '',
                            championPhone: Utility.formatPhone(championPhone ?? '')
                        }, () => {
                            this.originalState = _.cloneDeep(this.state);
                            this.props.hideLoading();
                        });
                    } else {
                        this.props.hideLoading();
                    }
                });
            });
        } else {
            this.props.showLoading('Getting things ready, one moment please...').then(() => {
                Promise.all([
                    this.props.getLookupData(this.props.centerId, this.props.micrositeId),
                    this.props.getShortCode(ShortCodeType.Microsite),
                ]).then(async ([lookupDataResponse, shortCodeResponse]) => {
                    if (lookupDataResponse.data.success && shortCodeResponse.data.success) {
                        let {
                            coordinatorList,
                            coachList,
                            statusList,
                            genderList,
                            stateList,
                            donorOriginList,
                            micrositeTypeList,
                            languageList,
                            dashRegistrationList,
                            centerList,
                            aboTypeList,
                            armedServiceList
                        } = lookupDataResponse.data.results;

                        let shortCode = shortCodeResponse.data.results;

                        let qrCode = await generateQRCodePngDataURL(`${__NKR_ORG_URL__}/register/${shortCode}`);

                        this.setState({
                            shortCode,
                            centerId: this.props.centerId != null ? this.props.centerId : 0,
                            qrCode,
                            coordinatorList,
                            coachList,
                            statusList,
                            genderList,
                            stateList,
                            donorOriginList,
                            micrositeTypeList,
                            languageList,
                            dashRegistrationList,
                            centerList,
                            aboTypeList,
                            armedServiceList
                        });

                        // if (__ENVIRONMENT__ == 'dev') {
                        //     this.setState({
                        //         firstName: 'Tim',
                        //         lastName: 'Jagemann',
                        //         email: 'Timothy.jagemann@kidneyregistry.com',
                        //         phonePrimary: '2035552222',
                        //         addressLine1: '84 Dannell Drive',
                        //         city: 'Stamford',
                        //         stateId: 7,
                        //         postalCode: '06905',
                        //         birthdate: '09/12/1989',
                        //         genderId: 1,
                        //         languagePreferenceId: 0,
                        //         isVeteran: false
                        //     });
                        // }

                        this.props.hideLoading();
                    }
                });
            });
        }
    };

    getPreviousUrl = () => {
        if (this.props.isCoachView) {
            return `/${this.props.previousUrl}`;
        }

        return this.props.isAdmin ?
            `/admin/microsite/${this.props.previousUrl}`
            :
            `/center/${this.props.centerId}/microsite/${this.props.previousUrl}`;
    };

    validate = async () => {
        let {
            centerId,
            micrositeTypeId,
            confirmShortCode,
            coordinatorContactId,
            email,
            secondaryEmail,
            firstName,
            lastName,
            addressLine1,
            addressLine2,
            city,
            stateId,
            postalCode,
            birthdate,
            genderId,
            phonePrimary,
            guardianFirstName,
            guardianLastName,
            guardianEmail,
            guardianPhone,
            isVeteran,
            isVeteranUnknown,
            branchOfService,
            hasChampion,
            championName,
            championEmail,
            championPhone
        } = this.state;

        let isMinor = this.determineIfMinor(birthdate);

        let validation: IValidation = {
            center: centerId == -1 || centerId > 0,
            micrositeTypeId: micrositeTypeId >= 0,
            confirmShortCode: this.state.id == 0 || this.props.isConfirm ? confirmShortCode == true : true,
            coordinatorContactId: centerId > 0 ? coordinatorContactId > 0 : true,
            email: Utility.isNotNullOrBlank(email.trim()) && Utility.isValidEmail(email.trim()),
            secondaryEmail: Utility.isNotNullOrBlank(secondaryEmail.trim()) ? Utility.isValidEmail(secondaryEmail.trim()) : true,
            firstName: firstName != '',
            lastName: lastName != '',
            addressLine1: addressLine1 != '',
            city: city != '' ? CityValidation.Valid : CityValidation.NotSpecified,
            stateId: stateId > 0,
            postalCode: postalCode != '',
            birthdate: birthdate != '',
            genderId: genderId > 0,

            phonePrimary: true,
            phoneSecondary: true,

            guardianFirstName: isMinor ? (guardianFirstName != null && guardianFirstName != '') : true,
            guardianLastName: isMinor ? guardianLastName != null && guardianLastName != '' : true,
            guardianEmail: isMinor ? Utility.isNotNullOrBlank(guardianEmail) && Utility.isValidEmail(guardianEmail.trim()) : true,
            guardianPhone: isMinor ? guardianPhone != null && guardianPhone != '' : true,

            isVeteran: isVeteran != null || isVeteranUnknown,
            branchOfService: isVeteran ? (branchOfService != null && branchOfService > -1) : true,

            championName: hasChampion ? Utility.isNotNullOrBlank(championName.trim()) : true,
            championEmail: hasChampion ? Utility.isNotNullOrBlank(championEmail.trim()) && Utility.isValidEmail(championEmail.trim()) : true,
            championPhone: hasChampion ? Utility.isNotNullOrBlank(championPhone.trim()) : true,

            existingList: [],
        };

        let required =
            validation.center
            && validation.micrositeTypeId
            && validation.coordinatorContactId
            && validation.email && validation.secondaryEmail
            && validation.firstName && validation.lastName
            && validation.addressLine1 && validation.city && validation.stateId && validation.postalCode
            && validation.birthdate
            && validation.genderId
            && validation.confirmShortCode

            && validation.guardianFirstName
            && validation.guardianLastName
            && validation.guardianEmail
            && validation.guardianPhone
            && validation.isVeteran
            && validation.branchOfService
            && validation.championName
            && validation.championEmail
            && validation.championPhone;

        if (required && this.state.id == 0) {
            let existingResponse = await this.props.checkForExistingRegistrations(
                email,
                firstName,
                lastName,
                birthdate
            );

            validation.existingList = existingResponse.data.results;
        }

        let addressValidation = this.state.addressValidation;

        if (required && validation.existingList.length == 0 && validation.addressLine1 && validation.city && validation.stateId && validation.postalCode) {
            let s = this.state.stateList.find(x => x.id == stateId);

            let validateAddressResponse = await this.props.validateAddress(addressLine1, addressLine2, city, s.abbreviation, postalCode);

            addressValidation.response = validateAddressResponse.data.results;
        }

        return { validation, addressValidation };
    }

    isValid = () => {
        let {
            center,
            micrositeTypeId,
            coordinatorContactId,
            email,
            secondaryEmail,
            firstName,
            lastName,
            addressLine1,
            city,
            stateId,
            postalCode,
            birthdate,
            genderId,

            guardianFirstName,
            guardianLastName,
            guardianEmail,
            guardianPhone,
            isVeteran,
            branchOfService,
            championName,
            championEmail,
            championPhone,

            existingList,
            confirmShortCode
        } = this.state.validation;

        let required =
            center
            && micrositeTypeId
            && coordinatorContactId
            && email && secondaryEmail
            && firstName && lastName
            && addressLine1 && city && stateId && postalCode
            && birthdate
            && genderId
            && confirmShortCode
            && guardianFirstName
            && guardianLastName
            && guardianEmail
            && guardianPhone
            && isVeteran
            && branchOfService
            && championName
            && championEmail
            && championPhone;

        let addressValid = this.state.addressValidation.response != null ? this.state.addressValidation.response.result == AddressValidationResult.Valid : true;

        let allValid = required && addressValid && existingList.length == 0;

        return { required, addressValid, existingList: existingList.length == 0, allValid };
    }

    save = (addressLine1: string, city: string, stateId: number, postalCode: string, changesConfirmed: boolean = false) => {
        if (this.props.isCoachView && !changesConfirmed) {
            this.setState({ pendingSave: { addressLine1, city, stateId, postalCode } });
            return;
        }

        let {
            id,
            shortCode,
            editKey,
            centerId,
            micrositeTypeId,
            coordinatorContactId,
            secondaryCoordinatorContactId,
            coachContactId,
            email,
            secondaryEmail,
            addressLine2,
            firstName,
            lastName,
            currentStatusId,
            birthdate,
            genderId,
            languagePreferenceId,
            aboTypeId,
            isResponsibilityConfirmed,
            receiveWeeklyUpdate: isPatientUpdateEnabled,
            transplantDate,
            donorOrigin,
            transplantedFromDashRegistration,
            dashRegistrationId,
            reason,
            isCoachingDesired,
            phonePrimary,
            phoneSecondary,
            guardianEmail,
            guardianFirstName,
            guardianLastName,
            guardianPhone,
            isVeteran,
            branchOfService,
            hasChampion,
            championName,
            championEmail,
            championPhone
        } = this.state;

        email = email.trim();

        let isMinor = this.determineIfMinor(birthdate);

        let request: IMicrositeRecipientRequest = {
            id,
            shortCode,
            editKey,
            centerId,
            campaignId: 0,
            coordinatorContactId,
            secondaryCoordinatorContactId: secondaryCoordinatorContactId > 0 ? secondaryCoordinatorContactId : null,
            coachContactId: coachContactId > 0 ? coachContactId : null,
            email,
            secondaryEmail,
            phonePrimary,
            phoneSecondary,
            firstName,
            lastName,
            currentStatusId,
            isDeleted: false,
            isTestSite: false,
            addressLine1,
            addressLine2,
            city,
            stateId,
            postalCode,
            birthdate,
            genderId,
            languagePreferenceId,
            aboTypeId: aboTypeId == -1 ? null : aboTypeId,
            isResponsibilityConfirmed,
            isPatientUpdateEnabled,
            transplantDate,
            donorOrigin,
            transplantedFromDashRegistration,
            dashRegistrationId,
            reason,
            micrositeTypeId,
            isConfirm: this.props.isConfirm,
            isCoachingDesired,
            guardianEmail: isMinor ? guardianEmail : null,
            guardianFirstName: isMinor ? guardianFirstName : null,
            guardianLastName: isMinor ? guardianLastName : null,
            guardianPhone: isMinor ? guardianPhone : null,
            isVeteran,
            branchOfService,
            hasChampion,
            championName: hasChampion ? championName : null,
            championEmail: hasChampion ? championEmail : null,
            championPhone: hasChampion ? championPhone : null
        };

        let message = id == 0 ?
            'Sending microsite invitation, one moment please...'
            :
            'Saving microsite registration, one moment please...';

        let successMessage = id == 0 ?
            'Invitation sent successfully'
            :
            'Registration saved successfully';

        let nextUrl = '';

        if (id == 0) {
            if (this.props.isAdmin) {
                nextUrl = '/admin/microsite/pending-patient';
            } else {
                nextUrl = `/center/${this.props.centerId}/microsite/pending-patient`;
            }
        } else {
            nextUrl = this.state.previousLocation;
        }

        if (this.props.isConfirm) {
            message = 'Activating starter site, one moment please...';
            successMessage = 'Started site activated successfully';

            nextUrl = this.props.isAdmin ?
                '/admin/microsite/active-starter-sites'
                :
                `/center/${this.props.centerId}/microsite/active-starter-sites`;
        }

        this.setState({
            disableSubmit: true
        }, () => {
            this.props.showLoading(message).then(() => {
                this.props.saveMicrosite(request)
                    .then(response => {
                        if (response.data.success) {
                            toast.success(successMessage, {
                                onClose: () => {
                                    window.location.href = nextUrl;
                                },
                            });
                        }
                    })
                    .catch(error => {
                        this.setState({
                            disableSubmit: false
                        });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    };

    getTitle = () => {
        let title = this.props.micrositeId > 0 ?
            'Edit Microsite Registration'
            :
            'Send Microsite Invite to Recipient';

        if (this.props.isConfirm) {
            title = 'Confirm New Microsite Recipient Details';
        }

        return title;
    };

    handleGetShortCode = () => {
        this.props.getShortCode(ShortCodeType.Microsite).then(async (response) => {
            if (response.data.success) {
                let qrCode = await generateQRCodePngDataURL(`${__NKR_ORG_URL__}/register/${response.data.results}`);

                this.setState({
                    shortCode: response.data.results,
                    qrCode
                });
            }
        });
    };

    handleFieldChange = (e: React.ChangeEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let state = _.cloneDeep(this.state);
        let { name, value } = e.currentTarget;

        let textFields = [
            'firstName',
            'lastName',
            'email',
            'secondaryEmail',
            'phonePrimary',
            'phoneSecondary',
            'addressLine1',
            'addressLine2',
            'city',
            'postalCode',
            'birthdate',
            'guardianFirstName',
            'guardianLastName',
            'guardianEmail',
            'guardianPhone',
            'championName',
            'championEmail',
            'championPhone',
        ];

        if (textFields.includes(name)) {
            state[name] = value;
        }

        let dropdownFields = [
            'centerId',
            'micrositeTypeId',
            'coordinatorContactId',
            'secondaryCoordinatorContactId',
            'coachContactId',
            'stateId',
            'genderId',
            'aboTypeId',
            'languagePreferenceId',
            'branchOfService',
            'isVeteran'
        ];

        if (dropdownFields.includes(name)) {
            state[name] = value ? parseInt(value, 10) : 0;

            if (name == 'centerId') {
                state.coordinatorContactId = 0;
                state.secondaryCoordinatorContactId = 0;

                let coachContact = this.state.coachList.find(
                    (x) => x.id == this.state.coachContactId
                );

                if (coachContact != null) {
                    if (coachContact.entityType == ContactEntityType.Center) {
                        state.coachContactId = 0;
                    }
                }
            }
        }

        if (name == 'confirmShortCode') {
            state.confirmShortCode = e.currentTarget.checked;
        }

        if (name == 'isCoachingDesired') {
            state.isCoachingDesired = e.currentTarget.checked == false;
        }

        if (name == 'hasChampion') {
            state.hasChampion = value === 'true';
        }

        if (name == 'isVeteran') {
            if (value == 'unknown') {
                state.isVeteran = null;
                state.isVeteranUnknown = true;
            } else if (value == '') {
                state.isVeteran = null;
                state.isVeteranUnknown = false;
            } else {
                state.isVeteran = value === 'true';
                state.isVeteranUnknown = false;
            }
        }

        this.setState(state);
    };

    handleSave = async () => {
        let { validation, addressValidation } = await this.validate();

        this.setState({
            validation,
            addressValidation,
            dirty: true
        }, () => {
            let { required, addressValid, existingList } = this.isValid();

            let isValid = required
                && addressValid
                && existingList
                && addressValid

            if (!addressValid) {
                let stateEntity = this.state.stateList.find(x => x.id == this.state.stateId);

                this.setState({
                    disableSubmit: false,
                    addressValidation: {
                        show: true,
                        response: addressValidation.response,
                        submittedAddress: {
                            street: this.state.addressLine1,
                            street2: this.state.addressLine2,
                            city: this.state.city,
                            state: stateEntity != null ? stateEntity.description : '',
                            postalCode: this.state.postalCode
                        }
                    },
                    dirty: true
                }, () => {
                    this.props.hideLoading();
                    window.scrollTo(0, 0);
                });
            } else {
                if (!isValid) {
                    window.scrollTo(0, 0);
                } else {
                    let { addressLine1, city, stateId, postalCode } = this.state;

                    this.save(addressLine1, city, stateId, postalCode);
                }
            }
        });
    };

    handleSubmitWithAddress = (recommended: boolean) => {
        let addressValidation = _.cloneDeep(this.state.addressValidation);

        addressValidation.response.result = AddressValidationResult.Valid;

        let { response } = this.state.addressValidation;

        let { addressLine1, addressLine2, city, stateId, postalCode } = this.state;

        if (recommended) {
            stateId = this.state.stateList.find(x => x.abbreviation == response.state).id;
            addressLine1 = response.address1;
            addressLine2 = response.address2;
            city = response.city;
            postalCode = response.zip5;
        }

        this.setState({
            addressLine1,
            addressLine2,
            city,
            stateId,
            postalCode,
            addressValidation: { ...addressValidation, show: false }
        }, () => {
            let { allValid } = this.isValid();

            if (!allValid) {
                window.scrollTo(0, 0);
            } else {
                this.save(addressLine1, city, stateId, postalCode);
            }
        });
    };

    handleCancelAddressSelection = () => {
        this.setState({
            addressValidation: { ...this.state.addressValidation, show: false }
        });
    };

    handleCancel = () => {
        window.location.href = this.getPreviousUrl();
    };

    getChangedDetails = (): IChangedDetail[] => {
        if (this.originalState == null) {
            return [];
        }

        const { centerList, micrositeTypeList, coordinatorList, coachList, stateList, genderList, languageList, armedServiceList } = this.state;

        const describe = (list: { id: number, description?: string }[], id: number) => list.find(x => x.id == id)?.description;

        const fields: [string, (s: IState) => string][] = [
            ['Center', s => s.centerId == -1 ? '- NO CENTER -' : centerList.find(x => x.id == s.centerId)?.alias],
            ['Type', s => describe(micrositeTypeList, s.micrositeTypeId)],
            ['Coordinator', s => coordinatorList.find(x => x.id == s.coordinatorContactId)?.fullName],
            ['Secondary Coordinator', s => coordinatorList.find(x => x.id == s.secondaryCoordinatorContactId)?.fullName],
            ['Coach Opt-Out', s => s.isCoachingDesired ? 'No' : 'Yes'],
            ['Coach', s => coachList.find(x => x.id == s.coachContactId)?.fullName],
            ['First Name', s => s.firstName],
            ['Last Name', s => s.lastName],
            ['Email', s => s.email],
            ['Secondary Email', s => s.secondaryEmail],
            ['Primary Phone', s => s.phonePrimary],
            ['Secondary Phone', s => s.phoneSecondary],
            ['Street Address', s => s.addressLine1],
            ['Unit/Apt', s => s.addressLine2],
            ['City', s => s.city],
            ['State', s => describe(stateList, s.stateId)],
            ['Postal Code', s => s.postalCode],
            ['Date of Birth', s => s.birthdate],
            ['Gender', s => describe(genderList, s.genderId)],
            ['Parent/Guardian First Name', s => s.guardianFirstName],
            ['Parent/Guardian Last Name', s => s.guardianLastName],
            ['Parent/Guardian Email', s => s.guardianEmail],
            ['Parent/Guardian Phone', s => s.guardianPhone],
            ['Language Preference', s => describe(languageList, s.languagePreferenceId)],
            ['Veteran', s => s.isVeteranUnknown ? 'Unknown' : s.isVeteran == null ? '' : s.isVeteran ? 'Yes' : 'No'],
            ['Branch', s => describe(armedServiceList, s.branchOfService)],
        ];

        return fields
            .map(([label, getValue]) => ({
                label,
                original: (getValue(this.originalState) ?? '').toString().trim(),
                updated: (getValue(this.state) ?? '').toString().trim(),
            }))
            .filter(x => x.original != x.updated);
    };

    handleConfirmChanges = () => {
        const { addressLine1, city, stateId, postalCode } = this.state.pendingSave;

        this.setState({ pendingSave: null }, () => {
            this.save(addressLine1, city, stateId, postalCode, true);
        });
    };

    handleCancelChanges = () => {
        this.setState({ pendingSave: null });
    };

    determineIfMinor = (birthdateValue: string | Date): boolean => {
        const dob = new Date(birthdateValue);

        if (isNaN(dob.getTime())) return false;

        const today = new Date();
        let age = today.getFullYear() - dob.getFullYear();
        const m = today.getMonth() - dob.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
            age--;
        }

        return age < 18;
    };

    render = () => {
        const title = this.getTitle();

        const { required, addressValid, existingList, allValid } = this.isValid();

        const centerList = _.sortBy(this.state.centerList, (item) => item.alias);

        const coordinatorList =
            this.state.centerId > 0 ?
                _.sortBy(
                    this.state.coordinatorList.filter(
                        (x) => x.entityTypeId == this.state.centerId
                    ),
                    (item) => item.fullName
                )
                :
                [];

        const isMinor = this.determineIfMinor(this.state.birthdate);

        const isAllowedToEdit = this.props.app.user.groupId == UserGroup.Admin;

        //const addressValid = this.state.addressValidation.response != null ? this.state.addressValidation.response.result == AddressValidationResult.Valid : true;

        return (
            <AddEditWrapper>
                {!allValid && addressValid && (
                    <Row>
                        <Col xs={12} md={9} mdOffset={1}>
                            <Alert bsStyle='danger'>
                                {!required && addressValid && (
                                    <div className='validation-section'>The items in red are required...</div>
                                )}

                                {!addressValid && (
                                    <div className='validation-section'>
                                        Due to the following address issues we are unable to process your request:
                                        <ul>
                                            {/* {this.state.validation.entireAddress.errors.map((e, i) =>
                                                <li key={'error-' + i} style={{ listStyleType: 'disc' }}>{e}</li>
                                            )} */}
                                        </ul>
                                    </div>
                                )}

                                {!existingList && (
                                    <div className='validation-section'>
                                        {this.state.validation.existingList.map((item, index) => (
                                            <div key={'validation-item-' + index}>
                                                This patient is already registered {item.centerAlias != '' ? 'at ' + item.centerAlias : ''} and cannot have two microsite registrations.
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.centerId != this.state.originalCenterId && this.state.id > 0 && (
                    <Row>
                        <Col xs={12} md={9} mdOffset={1}>
                            <Alert bsStyle='warning'>
                                Since the original center was changed, the coordinator, secondary coordinator and even the coach might have been reset. Please
                                review those fields below.
                            </Alert>
                        </Col>
                    </Row>
                )}

                <Row>
                    <Col xs={12} md={9} mdOffset={1}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginTop: 10,
                            }}
                        >
                            <h1 className='text-left' style={{ margin: 0 }}>
                                {title}
                            </h1>
                            <div className='dropdown pull-right'>
                                <Button
                                    bsStyle='link'
                                    onClick={this.handleCancel}
                                >
                                    Return to {this.props.previousName}
                                </Button>
                            </div>
                        </div>

                        <br />

                        <Panel>
                            <Panel.Body>
                                <FormWrapper horizontal>
                                    {this.props.isAdmin && (
                                        <FormGroup validationState={this.state.dirty && !this.state.validation.center ? 'error' : null}>
                                            <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='centerId'>{' '}Center:</Col>
                                            <Col xs={12} sm={8}>
                                                <FormControl
                                                    componentClass='select'
                                                    name='centerId'
                                                    value={this.state.centerId}
                                                    onChange={this.handleFieldChange}
                                                >
                                                    <option value={0}>- Please Select -</option>
                                                    <option value={-1}>- NO CENTER -</option>
                                                    {centerList.map((item, index) => (
                                                        <option key={'ctr-' + index} value={item.id}>
                                                            {item.alias}
                                                        </option>
                                                    ))}
                                                </FormControl>

                                                {this.state.dirty && !this.state.validation.center && (
                                                    <HelpBlock>
                                                        Please select a center or <strong>- NO CENTER -</strong>
                                                    </HelpBlock>
                                                )}
                                            </Col>
                                        </FormGroup>
                                    )}

                                    {this.state.campaignId > 0 && (
                                        <FormGroup validationState={this.state.dirty && !this.state.validation.micrositeTypeId ? 'error' : null}>
                                            <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='micrositeTypeId'>{' '}Campaign:</Col>
                                            <Col xs={12} sm={8}>
                                                <FormControl
                                                    disabled={true}
                                                    value={this.state.campaignName} />
                                            </Col>
                                        </FormGroup>
                                    )}

                                    <FormGroup validationState={this.state.dirty && !this.state.validation.micrositeTypeId ? 'error' : null}>
                                        <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='micrositeTypeId'>{' '}Type:</Col>
                                        <Col xs={12} sm={8}>
                                            <FormControl
                                                componentClass='select'
                                                name='micrositeTypeId'
                                                value={this.state.micrositeTypeId}
                                                disabled={this.state.campaignId > 0}
                                                onChange={this.handleFieldChange}
                                            >
                                                <option value={-1}>- Please Select -</option>
                                                {this.state.micrositeTypeList.map((item, index) => (
                                                    <option key={'coordinator-1-' + index} value={item.id}>
                                                        {item.description}
                                                    </option>
                                                ))}
                                            </FormControl>

                                            {this.state.dirty && !this.state.validation.micrositeTypeId && (
                                                <HelpBlock>
                                                    Please select a type
                                                </HelpBlock>
                                            )}

                                            {this.state.campaignId > 0 && (
                                                <HelpBlock>
                                                    This is specified by the campaign...
                                                </HelpBlock>
                                            )}
                                        </Col>
                                    </FormGroup>

                                    {this.state.centerId > 0 && (
                                        <>
                                            <FormGroup validationState={this.state.dirty && !this.state.validation.coordinatorContactId ? 'error' : null}>
                                                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='coordinatorContactId'>{' '}
                                                    Coordinator:
                                                </Col>
                                                <Col xs={12} sm={8}>
                                                    <FormControl
                                                        componentClass='select'
                                                        name='coordinatorContactId'
                                                        value={this.state.coordinatorContactId}
                                                        onChange={this.handleFieldChange}
                                                        disabled={!isAllowedToEdit}
                                                    >
                                                        <option value={0}>- Please Select -</option>
                                                        {coordinatorList.map((item, index) => (
                                                            <option key={'coordinator-1-' + index} value={item.id}>{item.fullName}</option>
                                                        ))}
                                                    </FormControl>

                                                    {this.state.dirty && !this.state.validation.coordinatorContactId && (
                                                        <HelpBlock>Please select a coordinator</HelpBlock>
                                                    )}
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='secondaryCoordinatorContactId'>
                                                    <Label style={{ marginRight: 5 }}>optional</Label>
                                                    <span>Secondary Coordinator:</span>
                                                </Col>
                                                <Col xs={12} sm={8}>
                                                    <FormControl
                                                        componentClass='select'
                                                        name='secondaryCoordinatorContactId'
                                                        value={this.state.secondaryCoordinatorContactId}
                                                        onChange={this.handleFieldChange}
                                                        disabled={!isAllowedToEdit}
                                                    >
                                                        <option value={0}>- Please Select -</option>
                                                        {coordinatorList.map((item, index) => (
                                                            <option key={'coordinator-2-' + index} value={item.id}>{item.fullName}</option>
                                                        ))}
                                                    </FormControl>
                                                </Col>
                                            </FormGroup>
                                        </>
                                    )}

                                    {this.props.micrositeId > 0 && (
                                        <FormGroup>
                                            <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='gender'>
                                                Coach Opt-Out:
                                            </Col>
                                            <Col xs={12} sm={7} style={{ marginTop: 5 }}>
                                                <input
                                                    type='checkbox'
                                                    name='isCoachingDesired'
                                                    checked={this.state.isCoachingDesired == false}
                                                    disabled={this.props.isAdmin == false && this.state.isCoachingDesiredOnLoad}
                                                    onChange={
                                                        this.handleFieldChange
                                                    }
                                                />
                                            </Col>
                                        </FormGroup>
                                    )}

                                    <FormGroup style={{ display: this.props.isAdmin ? 'block' : 'none' }}>
                                        <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='coachContactId'>
                                            <Label style={{ marginRight: 5 }}>optional</Label>
                                            <span>Coach:</span>
                                        </Col>
                                        <Col xs={12} sm={8}>
                                            <MicrositeSearchProvider value={{ coachList: this.state.coachList }}>
                                                <CoachSelector
                                                    value={this.state.coachContactId}
                                                    defaultText='- Please Select -'
                                                    allowNone={false}
                                                    name='coachContactId'
                                                    disabled={this.state.isCoachingDesired == false || !isAllowedToEdit}
                                                    onChange={this.handleFieldChange}
                                                />
                                            </MicrositeSearchProvider>
                                        </Col>
                                    </FormGroup>

                                    <FormGroup>
                                        <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='firstName'>{' '} Short Code:</Col>
                                        <Col xs={12} sm={8}>
                                            {this.props.isConfirm || this.state.id == 0 ? (
                                                <InputGroup>
                                                    <FormControl
                                                        readOnly={true}
                                                        maxLength={6}
                                                        value={this.state.shortCode}
                                                    />
                                                    <InputGroup.Button>
                                                        <Button onClick={this.handleGetShortCode}>
                                                            <span className='glyphicon glyphicon-refresh'></span>{' '}
                                                            Regenerate
                                                        </Button>
                                                    </InputGroup.Button>
                                                </InputGroup>
                                            ) : (
                                                <div className='form-control'>
                                                    {this.state.shortCode}
                                                </div>
                                            )}
                                        </Col>
                                    </FormGroup>

                                    {(this.props.isConfirm || this.state.id == 0) && (
                                        <FormGroup validationState={this.state.dirty && !this.state.validation.confirmShortCode ? 'error' : null}>
                                            <Col xs={12} sm={4}></Col>
                                            <Col xs={12} sm={8}>
                                                <Well bsSize='sm' style={{ marginBottom: 0, borderColor: this.state.dirty && !this.state.validation.confirmShortCode ? '#a94442' : '#ccc' }}>
                                                    <Checkbox name='confirmShortCode' checked={this.state.confirmShortCode} onChange={this.handleFieldChange}>
                                                        I confirm that the above computer-generated short-code doesn't have any text that could be perceived as
                                                        a word. (if it does have something that could be sounded out as a word, please click the Regenerate button to replace it).
                                                    </Checkbox>
                                                </Well>

                                                {this.state.dirty && !this.state.validation.confirmShortCode && (
                                                    <HelpBlock>
                                                        This is required to continue
                                                    </HelpBlock>
                                                )}
                                            </Col>
                                        </FormGroup>
                                    )}

                                    <FormGroup>
                                        <Col xs={12} sm={4} componentClass={ControlLabel}> QR Code:</Col>
                                        <Col xs={12} sm={2}>
                                            {this.state.qrCode && (
                                                <img src={this.state.qrCode} alt='QR Code' style={{ width: '100px', height: '100px' }} />
                                            )}
                                        </Col>

                                        <Col xs={12} sm={6}>
                                            <ControlLabel>Microsite Link</ControlLabel>
                                            <div><a href={`${__NKR_ORG_URL__}/${this.state.shortCode}`} target='_blank' rel='noopener noreferrer'>{`${__NKR_ORG_URL__}/${this.state.shortCode}`}</a></div>
                                        </Col>
                                    </FormGroup>

                                    <Row className='form-group'>
                                        <Col xs={12} sm={4} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.firstName ? 'text-danger' : null}>
                                            {' '} First Name:
                                        </Col>
                                        <Col xs={12} sm={3} className={this.state.dirty && !this.state.validation.firstName ? 'has-error' : null}>
                                            <FormControl
                                                name='firstName'
                                                value={this.state.firstName}
                                                onChange={this.handleFieldChange}
                                            />

                                            {this.state.dirty && !this.state.validation.firstName && (
                                                <HelpBlock>
                                                    Please enter the first name
                                                </HelpBlock>
                                            )}
                                        </Col>

                                        <Col xs={12} sm={2} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.lastName ? 'text-danger' : null}>
                                            {' '} Last Name:
                                        </Col>
                                        <Col xs={12} sm={3} className={this.state.dirty && !this.state.validation.lastName ? 'has-error' : null}>
                                            <FormControl
                                                name='lastName'
                                                value={this.state.lastName}
                                                onChange={this.handleFieldChange}
                                            />

                                            {this.state.dirty && !this.state.validation.lastName && (
                                                <HelpBlock>
                                                    Please enter the last name
                                                </HelpBlock>
                                            )}
                                        </Col>
                                    </Row>

                                    <Row className='form-group'>
                                        <Col xs={12} sm={4} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.email ? 'text-danger' : null}>
                                            {' '}
                                        </Col>
                                        <Col xs={12} sm={8} style={{ color: '#c9372e', paddingLeft: 15 }}>
                                            *Please ensure your First and Last Name are capitalized. This is how your name will appear on your Microsite.
                                        </Col>
                                    </Row>

                                    <Row className='form-group'>
                                        <Col xs={12} sm={4} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.email ? 'text-danger' : null}>
                                            {' '} Email:
                                        </Col>
                                        <Col xs={12} sm={3} className={this.state.dirty && !this.state.validation.email ? 'has-error' : null}>
                                            <FormControl
                                                name='email'
                                                value={this.state.email}
                                                onChange={this.handleFieldChange}
                                            />

                                            {this.state.dirty && !this.state.validation.email && (
                                                <HelpBlock>
                                                    Please enter the email
                                                </HelpBlock>
                                            )}
                                        </Col>
                                    </Row>

                                    <Row className='form-group'>
                                        <Col xs={12} sm={4} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.secondaryEmail ? 'text-danger' : null}>
                                            <Label style={{ marginRight: 5 }}>
                                                optional
                                            </Label>
                                            <span>Secondary&nbsp;Email:</span>
                                        </Col>
                                        <Col xs={12} sm={3} className={this.state.dirty && !this.state.validation.secondaryEmail ? 'has-error' : null} >
                                            <FormControl
                                                name='secondaryEmail'
                                                value={this.state.secondaryEmail}
                                                onChange={this.handleFieldChange}
                                            />

                                            {this.state.dirty && !this.state.validation.secondaryEmail && (
                                                <HelpBlock>
                                                    Secondary email is not in a valid format
                                                </HelpBlock>
                                            )}
                                        </Col>
                                    </Row>

                                    {!this.props.isAdmin ? (
                                        <Row className='form-group'>
                                            {this.state.phonePrimary && (
                                                <>
                                                    <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='phonePrimary'>
                                                        Phone:
                                                    </Col>
                                                    <Col xs={12} sm={3}>
                                                        <label style={{ marginTop: 5, }}>
                                                            {this.state.phonePrimary}
                                                        </label>
                                                    </Col>
                                                </>
                                            )}

                                            {this.state.phoneSecondary && (
                                                <>
                                                    <Col xs={12} sm={2} componentClass={ControlLabel} htmlFor='phoneSecondary'>
                                                        <span>
                                                            Alternate Phone:
                                                        </span>
                                                    </Col>
                                                    <Col xs={12} sm={3}>
                                                        <label style={{ marginTop: 5 }}>
                                                            {this.state.phoneSecondary}
                                                        </label>
                                                    </Col>
                                                </>
                                            )}
                                        </Row>
                                    ) : (
                                        <>
                                            <Row className='form-group'>
                                                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='phonePrimary'>
                                                    Primary Phone:
                                                </Col>
                                                <Col xs={12} sm={3}>
                                                    <FormControl
                                                        name='phonePrimary'
                                                        value={this.state.phonePrimary}
                                                        onChange={this.handleFieldChange}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className='form-group'>
                                                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='phoneSecondary'>
                                                    <span>Secondary Phone:</span>
                                                </Col>
                                                <Col xs={12} sm={3}>
                                                    <FormControl
                                                        name='phoneSecondary'
                                                        value={this.state.phoneSecondary}
                                                        onChange={this.handleFieldChange}
                                                    />
                                                </Col>
                                            </Row>
                                        </>
                                    )}

                                    <FormGroup validationState={this.state.dirty && !this.state.validation.addressLine1 ? 'error' : null}>
                                        <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='addressLine1'>
                                            Street Address:
                                        </Col>
                                        <Col xs={12} sm={8}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <FormControl
                                                    name='addressLine1'
                                                    value={this.state.addressLine1}
                                                    onChange={this.handleFieldChange}
                                                />
                                            </div>

                                            {this.state.dirty && !this.state.validation.addressLine1 && (
                                                <HelpBlock>
                                                    Please enter the street address
                                                </HelpBlock>
                                            )}
                                        </Col>
                                    </FormGroup>

                                    <FormGroup>
                                        <Col xs={12} sm={4} componentClass={ControlLabel}>
                                            Unit/Apt:
                                        </Col>
                                        <Col xs={4} sm={2}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <FormControl
                                                    name='addressLine2'
                                                    value={this.state.addressLine2}
                                                    onChange={this.handleFieldChange}
                                                />
                                            </div>
                                        </Col>
                                    </FormGroup>

                                    <Row className='form-group'>
                                        <Col xs={12} sm={4} componentClass={ControlLabel} className={this.state.dirty && this.state.validation.city != CityValidation.Valid ? 'text-danger' : null}>
                                            City:
                                        </Col>
                                        <Col xs={12} sm={2} className={this.state.dirty && this.state.validation.city != CityValidation.Valid ? 'has-error' : null}>
                                            <FormControl
                                                name='city'
                                                value={this.state.city}
                                                onChange={this.handleFieldChange}
                                            />

                                            {this.state.dirty && this.state.validation.city == CityValidation.NotSpecified && (
                                                <HelpBlock>
                                                    Please enter the city
                                                </HelpBlock>
                                            )}

                                            {this.state.dirty && this.state.validation.city == CityValidation.Invalid && (
                                                <HelpBlock>
                                                    That city doesn't exist
                                                </HelpBlock>
                                            )}
                                        </Col>

                                        <Col xs={12} sm={1} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.stateId ? 'text-danger' : null}>
                                            State:
                                        </Col>
                                        <Col xs={12} sm={2} className={this.state.dirty && !this.state.validation.stateId ? 'has-error' : null}>
                                            <FormControl
                                                componentClass='select'
                                                name='stateId'
                                                value={this.state.stateId}
                                                onChange={this.handleFieldChange}
                                            >
                                                <option value={-1}>
                                                    - Please Select -
                                                </option>
                                                {this.state.stateList.map((item, index) => (
                                                    <option key={'state-' + index} value={item.id}>
                                                        {item.description}
                                                    </option>
                                                ))}
                                            </FormControl>

                                            {this.state.dirty && !this.state.validation.stateId && (
                                                <HelpBlock>
                                                    Please select a state
                                                </HelpBlock>
                                            )}
                                        </Col>

                                    </Row>

                                    <Row className='form-group'>
                                        <Col xs={12} sm={4} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.postalCode ? 'text-danger' : null}>
                                            Postal&nbsp;Code:
                                        </Col>
                                        <Col xs={12} sm={2} className={this.state.dirty && !this.state.validation.postalCode ? 'has-error' : null}>
                                            <FormControl
                                                name='postalCode'
                                                value={this.state.postalCode}
                                                onChange={this.handleFieldChange}
                                            />

                                            {this.state.dirty && !this.state.validation.postalCode && (
                                                <HelpBlock>
                                                    Please enter the postal code
                                                </HelpBlock>
                                            )}
                                        </Col>
                                    </Row>

                                    <Row className='form-group'>
                                        <Col xs={12} sm={4} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.birthdate ? 'text-danger' : null}>
                                            Date of Birth:
                                        </Col>
                                        <Col xs={12} sm={2} className={this.state.dirty && !this.state.validation.birthdate ? 'has-error' : null}>
                                            <MaskedInput
                                                name='birthdate'
                                                className='form-control'
                                                mask='11/11/1111'
                                                placeholder='mm/dd/yyyy'
                                                style={{
                                                    borderColor: this.state
                                                        .validation.birthdate
                                                        ? '#ccc'
                                                        : '#a94442',
                                                }}
                                                value={this.state.birthdate}
                                                onChange={
                                                    this.handleFieldChange
                                                }
                                            />

                                            {this.state.dirty && !this.state.validation.birthdate && (
                                                <HelpBlock>
                                                    Please enter the date of birth
                                                </HelpBlock>
                                            )}
                                        </Col>

                                        <Col xs={12} sm={1} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.genderId ? 'text-danger' : null}>
                                            Gender:
                                        </Col>
                                        <Col xs={12} sm={2} className={this.state.dirty && !this.state.validation.genderId ? 'has-error' : null}>
                                            <FormControl
                                                componentClass='select'
                                                name='genderId'
                                                value={this.state.genderId}
                                                onChange={this.handleFieldChange}
                                            >
                                                <option value={-1}>
                                                    - Please Select -
                                                </option>
                                                {this.state.genderList.map((item, index) => (
                                                    <option key={'gender-' + index} value={item.id} >
                                                        {item.description}
                                                    </option>
                                                ))}
                                            </FormControl>

                                            {this.state.dirty && !this.state.validation.genderId && (
                                                <HelpBlock>
                                                    Please select a gender
                                                </HelpBlock>
                                            )}
                                        </Col>
                                    </Row>

                                    {isMinor && (
                                        <>
                                            <Row className='form-group'>
                                                <Col xs={12} sm={4} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.guardianFirstName ? 'text-danger' : null}>
                                                    Parent/Guardian First Name:
                                                </Col>
                                                <Col xs={12} sm={3} className={this.state.dirty && !this.state.validation.guardianFirstName ? 'has-error' : null}>
                                                    <FormControl
                                                        name='guardianFirstName'
                                                        value={this.state.guardianFirstName}
                                                        onChange={this.handleFieldChange}
                                                    />
                                                    {this.state.dirty && !this.state.validation.guardianFirstName && (
                                                        <HelpBlock>
                                                            Please enter the parent/guardian first name
                                                        </HelpBlock>
                                                    )}
                                                </Col>

                                                <Col xs={12} sm={2} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.guardianLastName ? 'text-danger' : null}>
                                                    Parent/Guardian Last Name:
                                                </Col>
                                                <Col xs={12} sm={3} className={this.state.dirty && !this.state.validation.guardianLastName ? 'has-error' : null}>
                                                    <FormControl
                                                        name='guardianLastName'
                                                        value={this.state.guardianLastName}
                                                        onChange={this.handleFieldChange}
                                                    />
                                                    {this.state.dirty && !this.state.validation.guardianLastName && (
                                                        <HelpBlock>
                                                            Please enter the parent/guardian last name
                                                        </HelpBlock>
                                                    )}
                                                </Col>
                                            </Row>

                                            <Row className='form-group'>
                                                <Col xs={12} sm={4} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.guardianEmail ? 'text-danger' : null}>
                                                    Parent/Guardian Email:
                                                </Col>
                                                <Col xs={12} sm={3} className={this.state.dirty && !this.state.validation.guardianEmail ? 'has-error' : null}>
                                                    <FormControl
                                                        name='guardianEmail'
                                                        value={this.state.guardianEmail}
                                                        onChange={this.handleFieldChange}
                                                    />
                                                    {this.state.dirty && !this.state.validation.guardianEmail && (
                                                        <HelpBlock>
                                                            Please enter the parent/guardian email
                                                        </HelpBlock>
                                                    )}
                                                </Col>

                                                <Col xs={12} sm={2} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.guardianPhone ? 'text-danger' : null}>
                                                    Parent/Guardian Phone:
                                                </Col>
                                                <Col xs={12} sm={3} className={this.state.dirty && !this.state.validation.guardianPhone ? 'has-error' : null}>
                                                    <FormControl
                                                        name='guardianPhone'
                                                        value={this.state.guardianPhone}
                                                        onChange={this.handleFieldChange}
                                                    />
                                                    {this.state.dirty && !this.state.validation.guardianPhone && (
                                                        <HelpBlock>
                                                            Please enter the parent/guardian phone number
                                                        </HelpBlock>
                                                    )}
                                                </Col>
                                            </Row>
                                        </>
                                    )}

                                    <Row className='form-group'>
                                        <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='languagePreferenceId'>
                                            Language Preference:
                                        </Col>
                                        <Col xs={12} sm={2}>
                                            <FormControl
                                                componentClass='select'
                                                name='languagePreferenceId'
                                                value={this.state.languagePreferenceId}
                                                onChange={this.handleFieldChange}
                                            >
                                                <option value={-1}>
                                                    - Please Select -
                                                </option>
                                                {this.state.languageList.map((item, index) => (
                                                    <option key={'lang-' + index} value={item.id}>
                                                        {item.description}
                                                    </option>
                                                ))}
                                            </FormControl>
                                        </Col>
                                    </Row>

                                    <Row className='form-group'>
                                        <Col xs={12} sm={4} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.isVeteran ? 'text-danger' : null}>
                                            Are you a Veteran?
                                        </Col>
                                        <Col xs={12} sm={2} className={this.state.dirty && !this.state.validation.isVeteran ? 'has-error' : null}>
                                            <FormControl
                                                componentClass='select'
                                                name='isVeteran'
                                                value={this.state.isVeteranUnknown ? 'unknown' : (this.state.isVeteran?.toString() ?? '')}
                                                onChange={this.handleFieldChange}
                                            >
                                                <option value=''>- Please Select -</option>
                                                <option value='true'>Yes</option>
                                                <option value='false'>No</option>
                                                <option value='unknown'>Unknown</option>
                                            </FormControl>

                                            {this.state.dirty && !this.state.validation.isVeteran && (
                                                <HelpBlock>
                                                    Please select if you are a Veteran
                                                </HelpBlock>
                                            )}
                                        </Col>

                                        <Col xs={12} sm={1} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.branchOfService ? 'text-danger' : null}>
                                            Branch:                                       </Col>
                                        <Col xs={12} sm={2} className={this.state.dirty && !this.state.validation.branchOfService ? 'has-error' : null}>
                                            <FormControl
                                                componentClass='select'
                                                name='branchOfService'
                                                value={this.state.branchOfService}
                                                disabled={this.state.isVeteran != true}
                                                onChange={this.handleFieldChange}
                                            >
                                                <option value={-1}>
                                                    - Please Select -
                                                </option>
                                                {this.state.armedServiceList.map((item, index) => (
                                                    <option key={'asl-' + index} value={item.id}>
                                                        {item.description}
                                                    </option>
                                                ))}
                                            </FormControl>

                                            {this.state.dirty && !this.state.validation.branchOfService && (
                                                <HelpBlock>
                                                    Please select the  branch of service
                                                </HelpBlock>
                                            )}
                                        </Col>
                                    </Row>

                                    {this.props.micrositeId > 0 && (
                                        <>
                                            <Row className='form-group'>
                                                <Col xs={12} sm={4} componentClass={ControlLabel}>
                                                    Donor Search Champion:
                                                </Col>
                                                <Col xs={12} sm={8}>
                                                    <Radio
                                                        inline
                                                        name='hasChampion'
                                                        id='hasChampionYes'
                                                        value='true'
                                                        checked={this.state.hasChampion == true}
                                                        onChange={this.handleFieldChange}
                                                    >
                                                        Yes
                                                    </Radio>
                                                    <Radio
                                                        inline
                                                        name='hasChampion'
                                                        id='hasChampionNo'
                                                        value='false'
                                                        checked={this.state.hasChampion != true}
                                                        onChange={this.handleFieldChange}
                                                    >
                                                        No
                                                    </Radio>
                                                </Col>
                                            </Row>

                                            {this.state.hasChampion && (
                                                <>
                                                    <Row className='form-group'>
                                                        <Col xs={12} sm={4} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.championName ? 'text-danger' : null}>
                                                            Champion Name:
                                                        </Col>
                                                        <Col xs={12} sm={3} className={this.state.dirty && !this.state.validation.championName ? 'has-error' : null}>
                                                            <FormControl
                                                                name='championName'
                                                                maxLength={255}
                                                                value={this.state.championName}
                                                                onChange={this.handleFieldChange}
                                                            />
                                                            {this.state.dirty && !this.state.validation.championName && (
                                                                <HelpBlock>
                                                                    Please enter the champion name
                                                                </HelpBlock>
                                                            )}
                                                        </Col>
                                                    </Row>

                                                    <Row className='form-group'>
                                                        <Col xs={12} sm={4} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.championEmail ? 'text-danger' : null}>
                                                            Champion Email:
                                                        </Col>
                                                        <Col xs={12} sm={3} className={this.state.dirty && !this.state.validation.championEmail ? 'has-error' : null}>
                                                            <FormControl
                                                                name='championEmail'
                                                                maxLength={255}
                                                                value={this.state.championEmail}
                                                                onChange={this.handleFieldChange}
                                                            />
                                                            {this.state.dirty && !this.state.validation.championEmail && (
                                                                <HelpBlock>
                                                                    Please enter a valid champion email
                                                                </HelpBlock>
                                                            )}
                                                        </Col>
                                                    </Row>

                                                    <Row className='form-group'>
                                                        <Col xs={12} sm={4} componentClass={ControlLabel} className={this.state.dirty && !this.state.validation.championPhone ? 'text-danger' : null}>
                                                            Champion Mobile Phone:
                                                        </Col>
                                                        <Col xs={12} sm={3} className={this.state.dirty && !this.state.validation.championPhone ? 'has-error' : null}>
                                                            <FormControl
                                                                name='championPhone'
                                                                maxLength={20}
                                                                placeholder='123-456-7890'
                                                                value={this.state.championPhone}
                                                                onChange={this.handleFieldChange}
                                                            />
                                                            {this.state.dirty && !this.state.validation.championPhone && (
                                                                <HelpBlock>
                                                                    Please enter the champion mobile phone
                                                                </HelpBlock>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                        </>
                                    )}
                                    {/* {this.props.micrositeId > 0 && (
                                        <FormGroup>
                                            <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='gender'>
                                                Coach Opt-Out:
                                            </Col>
                                            <Col xs={12} sm={7} style={{ marginTop: 5 }}>
                                                <input
                                                    type='checkbox'
                                                    name='isCoachingDesired'
                                                    checked={this.state.isCoachingDesired == false}
                                                    disabled={this.props.isAdmin == false}
                                                    onChange={
                                                        this.handleFieldChange
                                                    }
                                                />
                                            </Col>
                                        </FormGroup>
                                    )} */}
                                </FormWrapper>
                            </Panel.Body>
                        </Panel>

                        <FormGroup style={{ marginTop: 20 }}>
                            <Col xs={12} style={{ display: 'flex', justifyContent: 'center', }}>
                                <Button
                                    bsStyle='primary'
                                    bsSize='lg'
                                    className='col-xs-2'
                                    disabled={this.state.disableSubmit}
                                    style={{ marginRight: 5 }}
                                    onClick={this.handleSave}
                                >
                                    {this.props.isConfirm ? 'Confirm' : 'Save'}
                                </Button>
                                <Button
                                    className='col-xs-2'
                                    onClick={this.handleCancel}
                                >
                                    Cancel
                                </Button>
                            </Col>
                        </FormGroup>
                    </Col>
                </Row>

                <AddressValidation
                    show={this.state.addressValidation.show}
                    response={this.state.addressValidation.response}
                    submittedAddresss={this.state.addressValidation.submittedAddress}
                    onUseAddress={this.handleSubmitWithAddress}
                    onCancel={this.handleCancelAddressSelection}
                />

                <ConfirmChanges
                    show={this.state.pendingSave != null}
                    changes={this.state.pendingSave != null ? this.getChangedDetails() : []}
                    onConfirm={this.handleConfirmChanges}
                    onCancel={this.handleCancelChanges}
                />
            </AddEditWrapper>
        );
    };
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getMicrosite: (id, forCoach, confirm) => {
            return dispatch(MicrositeActionCreators.getMicrosite(id, forCoach, confirm));
        },
        getLookupData: (centerId, micrositeRecipientId) => {
            return dispatch(MicrositeActionCreators.getLookupData(centerId, micrositeRecipientId));
        },
        getShortCode: (type) => {
            return dispatch(MicrositeActionCreators.getShortCode(type));
        },
        saveMicrosite: (request) => {
            return dispatch(MicrositeActionCreators.saveMicrosite(request));
        },
        checkForExistingRegistrations: (email, firstName, lastName, birthDate) => {
            return dispatch(MicrositeActionCreators.checkForExistingRegistrations(email, firstName, lastName, birthDate));
        },
        validateAddress: (addressLine1, addressLine2, city, state, postalCode) => {
            return dispatch(DashActionCreators.validateAddress(addressLine1, addressLine2, city, state, postalCode));
        },
    };
};

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps
)(MicrositeAddEdit);
